import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

export default function StandardDataGrid({ rows, columns, columnIdVisibiliy, additionalInitialState }) {
    const combinedInitialState = {
        columns: {
            columnVisibilityModel: {
                id: columnIdVisibiliy,
            }
        },
        ...additionalInitialState
    };

    return (
        <DataGrid
            initialState={combinedInitialState}
            rows={rows}
            columns={columns}
            disableSelectionOnClick
        />
    );
}
